import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7682bfc5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "data-step-id"]
const _hoisted_2 = { class: "title-box" }
const _hoisted_3 = { class: "serial-number" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "step-content"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "prompt" }, "密码必须包含 1 个字母和 1 个数字，密码长度至少为 8 个字符，如需修改密码时输入任意字符或删除任意字符即可", -1))
const _hoisted_8 = { class: "form-box" }
const _hoisted_9 = {
  key: 1,
  class: "step-content"
}
const _hoisted_10 = {
  key: 0,
  class: "prompt"
}
const _hoisted_11 = {
  key: 1,
  class: "form-box"
}
const _hoisted_12 = {
  key: 2,
  class: "form-box"
}
const _hoisted_13 = { class: "operating-box" }
const _hoisted_14 = ["disabled", "onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["disabled", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_elem_icon = _resolveComponent("elem-icon")!
  const _component_elem_form = _resolveComponent("elem-form")!
  const _component_elem_form_node = _resolveComponent("elem-form-node", true)!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.forms, (conf, idx) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "item-box step-item",
      "dark-class": "create-page-dark",
      key: idx,
      id: 'FromItemBox-' + conf.name,
      "data-step-id": 'StepItemBox-' + conf.name
    }, [
      ($options.getConditionValueByValue(conf.where, $options.getScopedValue()))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["item-base step-base", 'step-item-' + idx])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, _toDisplayString($options.getStepNumber(idx)), 1),
              _createElementVNode("p", _hoisted_4, _toDisplayString(conf.title), 1),
              (conf.list)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "add-button",
                    onClick: ($event: any) => ($options.onChangeList('append', conf.name))
                  }, [
                    _createVNode(_component_elem_icon, {
                      class: "icon-box",
                      name: "add_blue"
                    })
                  ], 8, _hoisted_5))
                : _createCommentVNode("", true)
            ]),
            (conf.type === 'PASSWORD')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conf.data, (item, idx) => {
                      return (_openBlock(), _createBlock(_component_elem_form, {
                        index: Number(idx),
                        key: idx,
                        data: $options.stripWhere(item),
                        config: conf,
                        value: $options.getRootValue(),
                        entityPath: $props.entityPath,
                        onChangeData: $options.onChangeValue
                      }, null, 8, ["index", "data", "config", "value", "entityPath", "onChangeData"]))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (conf.prompt)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(conf.prompt), 1))
                    : _createCommentVNode("", true),
                  (!conf.list)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conf.data, (item, idx) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            (item.type !== 'List' && $options.getConditionValueByValue(item.where, $options.getScopedValue()))
                              ? (_openBlock(), _createBlock(_component_elem_form, {
                                  index: Number(idx),
                                  key: idx,
                                  data: $options.stripWhere(item),
                                  config: conf,
                                  value: $options.getRootValue(),
                                  entityPath: $props.entityPath,
                                  onChangeData: $options.onChangeValue
                                }, null, 8, ["index", "data", "config", "value", "entityPath", "onChangeData"]))
                              : (item.type === 'List' && $options.getConditionValueByValue(item.where, $options.getScopedValue()))
                                ? (_openBlock(), _createBlock(_component_elem_form_node, {
                                    key: 'node-' + idx,
                                    forms: item.data,
                                    value: $options.getRootValue(),
                                    rootValue: $options.getRootValue(),
                                    entityPath: $props.entityPath,
                                    onChangeData: $options.onChangeValue
                                  }, null, 8, ["forms", "value", "rootValue", "entityPath", "onChangeData"]))
                                : _createCommentVNode("", true)
                          ], 64))
                        }), 256))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getStepMap(conf), (sub, sub_idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "list-box",
                            key: sub.key_id
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conf.data, (item, idx) => {
                              return (_openBlock(), _createElementBlock(_Fragment, null, [
                                (item.type !== 'List' && $options.getConditionValueByValue(item.where, $options.getListItemValue(conf.name, sub_idx)))
                                  ? (_openBlock(), _createBlock(_component_elem_form, {
                                      key: sub.key_id + '-' + idx,
                                      data: $options.stripWhere(item),
                                      config: conf,
                                      value: $options.getRootValue(),
                                      entityPath: $options.getListItemPath(conf.name, sub_idx),
                                      onChangeData: $options.onChangeValue
                                    }, null, 8, ["data", "config", "value", "entityPath", "onChangeData"]))
                                  : (item.type === 'List' && $options.getConditionValueByValue(item.where, $options.getListItemValue(conf.name, sub_idx)))
                                    ? (_openBlock(), _createBlock(_component_elem_form_node, {
                                        key: sub.key_id + '-node-' + idx,
                                        forms: item.data,
                                        value: $options.getRootValue(),
                                        rootValue: $options.getRootValue(),
                                        entityPath: $options.getListItemPath(conf.name, sub_idx),
                                        onChangeData: $options.onChangeValue
                                      }, null, 8, ["forms", "value", "rootValue", "entityPath", "onChangeData"]))
                                    : _createCommentVNode("", true)
                              ], 64))
                            }), 256)),
                            _createElementVNode("div", _hoisted_13, [
                              _withDirectives(_createElementVNode("button", {
                                type: "button",
                                class: "move-button top",
                                disabled: Number(sub_idx) === 0,
                                onClick: ($event: any) => ($options.onChangeListSort('move-before', conf.name, Number(sub_idx)))
                              }, [
                                _createVNode(_component_elem_icon, {
                                  class: "icon-box",
                                  name: "arrow_bottom"
                                })
                              ], 8, _hoisted_14), [
                                [_vShow, $options.getStepMap(conf).length > 1]
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "clear-button",
                                onClick: ($event: any) => ($options.onChangeList('clear', conf.name, sub_idx))
                              }, [
                                _createVNode(_component_elem_icon, {
                                  class: "icon-box",
                                  name: "clear_red"
                                })
                              ], 8, _hoisted_15),
                              _createElementVNode("button", {
                                type: "button",
                                class: "add-button",
                                onClick: ($event: any) => ($options.onChangeList('append', conf.name))
                              }, [
                                _createVNode(_component_elem_icon, {
                                  class: "icon-box",
                                  name: "add_blue"
                                })
                              ], 8, _hoisted_16),
                              _withDirectives(_createElementVNode("button", {
                                type: "button",
                                class: "move-button bottom",
                                disabled: Number(sub_idx) === $options.getStepMap(conf).length - 1,
                                onClick: ($event: any) => ($options.onChangeListSort('move-after', conf.name, Number(sub_idx)))
                              }, [
                                _createVNode(_component_elem_icon, {
                                  class: "icon-box",
                                  name: "arrow_bottom"
                                })
                              ], 8, _hoisted_17), [
                                [_vShow, $options.getStepMap(conf).length > 1]
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
                ]))
          ], 2))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1))
  }), 128))
}